<template>
<div class="row" style="background-color: white;">
  <div class="Absolute-Center is-Responsive">
    <div id="logo-container"></div>
    <div style="font-size: 2em;">
      <p style="color: black;">Dental Place Medan</p>
    </div>
    <div v-if="isLoading" class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    <div v-if="isLoading">Logging you in... Please Wait</div>
    <div v-if="!isLoading" class="col-sm-12">
      <div class="form-group col-md-12">
        <input type="email" class="form-control" id="app-email-address" aria-describedby="emailHelp" placeholder="Email" v-model="body.email">
      </div>
      <div class="form-group col-md-12">
        <input type="password" @keyup.enter="login" class="form-control" id="exampleInputPassword1" placeholder="Password" v-model="body.password">
      </div>
      <button class="btn btn-primary btn-block" @click="login">Login</button> 
      <br>
      <router-link to="signUp" style="color: blue">Sign up here</router-link> or <router-link to="request-reset-password" style="color: red">reset password</router-link>
      <!-- <button class="btn btn-primary btn-block" @click="signup">Sign Up</button> 
      <br>
      <button class="btn btn-primary btn-block" @click="resetPassword">Reset Password</button>  -->
    </div>  
  </div>    
</div>
</template>

<script>
import api from '../services/api'
import { Login } from '../models/login'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      body: Login,
    }
  },
  computed: {
    ...mapState(['isLoading'])
  },
  methods: {
    ...mapActions(['appLogin', 'appLoading']),
    async login() {
      this.appLoading(true)
      const loginApi = api('login')
      const data = await loginApi.createWithResultAndToast(this.body)
      if (data.ok) {
        this.appLogin(data.data)
        this.$router.push({ name: 'dashboard' })
      }
      this.appLoading(false)
    },
    signup() {
      this.$router.push({ name: 'signUp' })
    },
    resetPassword() {
      this.$router.push({ name: 'requestResetPassword' })
    },
  }
}
</script>